var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.has-instance.js
// module id = 1291
// module chunks = 1